import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ConfettiExplosion from 'react-confetti-explosion';
import axios from 'axios';
import './Exam.css';
import Cookies from "js-cookie";
import { API } from '../backend';

const Exam = ({ setIsLoginOpen }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const sectionId = location.state?.sectionId;
    const examData = location.state?.examData || [];
    const [data, setData] = useState(examData);
    const [currentStep, setCurrentStep] = useState(0);
    const [answers, setAnswers] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [quizStatus, setQuizStatus] = useState(null);
    const [giftToken, setGiftToken] = useState(0);


    const currentQuestion = data[currentStep] || {};

    const handleSelectAnswer = (answer, answerId) => {
        setAnswers(prev => ({ ...prev, [currentStep]: { question_id: currentQuestion.id, answer_id: answerId } }));
    };

    const handleBack = () => {
        navigate(-1); // Navigate back to the previous page
    };


    const handleConfirm = () => {
    const resultArray = Object.values(answers);
    console.log(resultArray)


    const config = {
        headers: {
            "Content-Type": "application/json"
        }
    };

    const apiUrl = `${API}api/v1/quiz/?section_id=${sectionId}`;

    axios.post(apiUrl, resultArray, config)
        .then(response => {
            console.log("Response from API:", response.data);
            setQuizStatus(response.data.status);
            setShowModal(true);
            setGiftToken(response.data.gift_token || 0);
        })
        .catch(error => {
            console.error("Error submitting exam:", error);
            alert("Error submitting your answers. Please check your connection.");
        });
    };


  return (
    <>  
    <div className='exam-container'>
        <div className='exam-margin-top'></div>
        <div className='exam-title'>
            <p className='exam-title2'>{currentQuestion.section_title}</p>
            <div className='vertical-line'></div>
            <p className='exam-title1'>آزمون</p>
        </div>

        <div className="exam-steps">
            {data.map((_, index) => {
            const isActive = currentStep >= data.length - index - 1;
            return (
                <React.Fragment key={index}>
                <div className={`step ${isActive ? 'active-step' : ''}`}>
                    {data.length - index}
                </div>
                {index !== data.length - 1 && (
                    <div className={`horizontal-line ${isActive ? 'active-line' : ''}`}></div>
                )}
                </React.Fragment>
            );
            })}
        </div>

        <div className='exam-margin-between'></div>

        <div className='exam-question'>
            <button className='back-btn' onClick={handleBack}>بازگشت به درس</button>
            <p className='question-text'>{currentQuestion.title}</p>
        </div>

        <div className="exam-answer">
            {currentQuestion.answers && currentQuestion.answers.map((answer, index) => (
                <div className="answer-wrapper" key={index}>
                    <label className='answer-label'>
                        {answer.title}
                        <input
                            type="radio"
                            name={`exam-answer-${currentStep}`}
                            value={answer.id}
                            checked={answers[currentStep]?.answer_id === answer.id}
                            onChange={() => handleSelectAnswer(answer.title, answer.id)}
                        />
                        <span className="custom-radio"></span>
                    </label>
                </div>
            ))}
        </div>

        <div className='next-previous-btn'>
            {currentStep > 0 && (
                <button 
                    className='previous-btn' 
                    onClick={() => {
                        setCurrentStep(prev => Math.max(prev - 1, 0));
                        window.scrollTo(0, 0);
                    }}
                >
                    قبلی
                </button>
            )}
            
            <button 
                className='next-btn' 
                onClick={() => {
                    if (currentStep < data.length - 1) {
                        setCurrentStep(prev => prev + 1);
                    } else {
                        handleConfirm();
                    }
                    window.scrollTo(0, 0);
                }}
                disabled={!answers[currentStep]}
            >
                {currentStep === data.length - 1 ? "تایید" : "بعدی"}
            </button>
        </div>
        <div className='exam-margin-bottom'></div>
    </div>
    <div className='exam-container-mobile'>
        <div className='exam-margin-top-mobile'></div>
        <div className='exam-title-mobile'>
            <p className='exam-title2-mobile'>{currentQuestion.section_title}</p>
            <div className='vertical-line'></div>
            <p className='exam-title1-mobile'>آزمون</p>
        </div>
        <div className="exam-steps-mobile">
            {data.map((_, index) => {
            const isActive = currentStep >= data.length - index - 1;
            return (
                <React.Fragment key={index}>
                <div className={`step-mobile ${isActive ? 'active-step' : ''}`}>
                    {data.length - index}
                </div>
                {index !== data.length - 1 && (
                    <div className={`horizontal-line ${isActive ? 'active-line' : ''}`}></div>
                )}
                </React.Fragment>
            );
            })}
        </div>
        <div className='exam-margin-between-mobile'></div>

        <div className='exam-question-mobile'>
            <p className='question-text-mobile'>{currentQuestion.title}</p>
        </div>

        <div className="exam-answer-mobile">
            {currentQuestion.answers && currentQuestion.answers.map((answer, index) => (
                <div className="answer-wrapper-mobile" key={index}>
                    <label className='answer-label-mobile'>
                        {answer.title}
                        <input
                            type="radio"
                            name={`exam-answer-mobile-${currentStep}`}
                            value={answer.id}
                            checked={answers[currentStep]?.answer_id === answer.id}
                            onChange={() => handleSelectAnswer(answer.title, answer.id)}
                        />
                        <span className="custom-radio"></span>
                    </label>
                </div>
            ))}
        </div>

        <div className='next-previous-btn-mobile'>
            <div className='back-btn-mobile-div'>
                <button className='back-btn-mobile' onClick={handleBack}>بازگشت به درس</button>
            </div>
            
                {currentStep > 0 && (
                    <button 
                        className='previous-btn-mobile' 
                        onClick={() => {
                            setCurrentStep(prev => Math.max(prev - 1, 0));
                            window.scrollTo(0, 0);
                        }}
                    >
                        قبلی
                    </button>
                )}
            
            <button 
                className='next-btn-mobile' 
                onClick={() => {
                    if (currentStep < data.length - 1) {
                        setCurrentStep(prev => prev + 1);
                    } else {
                        handleConfirm();
                    }
                    window.scrollTo(0, 0);
                }}
                disabled={!answers[currentStep]}
            >
                {currentStep === data.length - 1 ? "تایید" : "بعدی"}
            </button>
        </div>

    </div>
        {showModal && (
            <>
                <div className="modal-overlay">
                    <div className="modal-content">
                        {quizStatus ? (
                            <>
                                <svg className='modal-svg' viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="50.0003" cy="50" r="33.3333" fill="#3CCFF1" fill-opacity="0.5" />
                                    <path d="M35.4167 45.8333L44.9704 55.3871C46.5976 57.0142 49.2358 57.0142 50.8629 55.3871L81.25 25" stroke="#E53B1F" stroke-width="5" stroke-linecap="round" />
                                </svg>
                                <p className='modal-title'>تبریک!</p>
                                <ConfettiExplosion 
                                    particleCount={200}
                                    duration={2000}
                                    width={700}
                                    force={0.8}
                                />
                                <div className='modal-line'></div>
                                <p className='modal-text'>شما {giftToken} توکن ایوا دریافت نمودید.</p>
                                <button 
                                    className='collect-modal' 
                                    onClick={() => {
                                        const token = Cookies.get('token');
                                        if (token) {
                                            const config = {
                                                headers: {
                                                    "Content-Type": "application/json",
                                                    "Authorization": `Token ${token}` // Include the token in the header
                                                }
                                            };
                                
                                            const apiUrl = `${API}api/v1/quiz/?section_id=${sectionId}`;

                                            const resultArray = Object.values(answers);
                                
                                            axios.post(apiUrl, resultArray, config) // Send an empty body or required payload
                                                .then(response => {
                                                    console.log("Token reward response:", response.data);
                                                    setShowModal(false);
                                                    navigate("/mycourse");
                                                })
                                                .catch(error => {
                                                    console.error("Error claiming reward:", error);
                                                    alert("Error claiming reward. Please try again later.");
                                                });
                                            
                                        } else {
                                            setIsLoginOpen(true);
                                            setShowModal(false);
                                        }
                                    }}>
                                    دریافت
                                </button>
                                
                            </>
                        ) : (
                            <>
                                <svg className='modal-svg' viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="50" cy="50" r="37.5" fill="#3CCFF1" fill-opacity="0.5" />
                                    <path d="M37.5 62.4987L62.5 37.4987" stroke="#E53B1F" stroke-width="5" />
                                    <path d="M62.5 62.5L37.5 37.5" stroke="#E53B1F" stroke-width="5" />
                                </svg>
                                <p className='modal-title'>پاسخ هایتان اشتباه بود!</p>
                                <div className='modal-line'></div>
                                <p className='modal-text'>پس از اتمام صحیح آزمون، کوپن های بازگشت نقدی به شما پاداش داده می شود.</p>
                                <button className='close-modal' onClick={() => {
                                    setShowModal(false);
                                    setCurrentStep(0);
                                    setAnswers({});
                                }}>
                                    بازگشت
                                </button>
                            </>
                        )}
                    </div>
                </div>

                <div className="modal-overlay-mobile">
                    <div className="modal-content-mobile">
                        {quizStatus ? (
                            <>
                                <svg className='modal-svg-mobile' viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="50.0003" cy="50" r="33.3333" fill="#3CCFF1" fill-opacity="0.5" />
                                    <path d="M35.4167 45.8333L44.9704 55.3871C46.5976 57.0142 49.2358 57.0142 50.8629 55.3871L81.25 25" stroke="#E53B1F" stroke-width="5" stroke-linecap="round" />
                                </svg>
                                <p className='modal-title-mobile'>تبریک!</p>
                                <ConfettiExplosion 
                                    particleCount={200}
                                    duration={2000}
                                    width={700}
                                    force={0.8}
                                />
                                <div className='modal-line'></div>
                                <p className='modal-text-mobile'>شما {giftToken} توکن ایوا دریافت نمودید.</p>
                                <button 
                                    className='collect-modal-mobile' 
                                    onClick={() => {
                                        const token = Cookies.get('token');
                                        if (token) {
                                            const config = {
                                                headers: {
                                                    "Content-Type": "application/json",
                                                    "Authorization": `Token ${token}` // Include the token in the header
                                                }
                                            };
                                
                                            const apiUrl = `${API}api/v1/quiz/?section_id=${sectionId}`;

                                            const resultArray = Object.values(answers);
                                
                                            axios.post(apiUrl, resultArray, config) // Send an empty body or required payload
                                                .then(response => {
                                                    console.log("Token reward response:", response.data);
                                                    setShowModal(false);
                                                    navigate("/mycourse");
                                                })
                                                .catch(error => {
                                                    console.error("Error claiming reward:", error);
                                                    alert("Error claiming reward. Please try again later.");
                                                });
                                            
                                        } else {
                                            setIsLoginOpen(true);
                                            setShowModal(false);
                                        }
                                    }}>
                                    دریافت
                                </button>
                                
                            </>
                        ) : (
                            <>
                                <svg className='modal-svg-mobile' viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="50" cy="50" r="37.5" fill="#3CCFF1" fill-opacity="0.5" />
                                    <path d="M37.5 62.4987L62.5 37.4987" stroke="#E53B1F" stroke-width="5" />
                                    <path d="M62.5 62.5L37.5 37.5" stroke="#E53B1F" stroke-width="5" />
                                </svg>
                                <p className='modal-title-mobile'>پاسخ هایتان اشتباه بود!</p>
                                <div className='modal-line'></div>
                                <p className='modal-text-mobile'>پس از اتمام صحیح آزمون، کوپن های بازگشت نقدی به شما پاداش داده می شود.</p>
                                <button className='collect-modal-mobile' onClick={() => {
                                    setShowModal(false);
                                    setCurrentStep(0);
                                    setAnswers({});
                                }}>
                                    بازگشت
                                </button>
                            </>
                        )}
                    </div>
                </div>
            </>
        )}
    </>
  );
};

export default Exam;
